import useProfile from 'hooks/useProfile';
import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom';
import { loadUsetifulScript } from 'usetiful-sdk';

const UseitfulWrapper = ({children}) => {

  const user = useProfile();
  const {pathname} = useLocation();

  useEffect(() => {
    if (user.isLogged) {
      loadUsetifulScript('a389fcca27e907fb8d5a9f4c685dc59e');
      sessionStorage.setItem('user', JSON.stringify(user))
    }
  }, [user])

  useEffect(() => {
    if (user.isLogged && window.USETIFUL) {
      window.USETIFUL.reinitialize();
    }
  }, [pathname])

  return (
    <>
      {children}
    </>
  )
}

export default UseitfulWrapper;
